import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import {
  getUserInfoApi,
  getUserSupportApi,
  supportStatusApi,
} from "../../../Api/PanelAdminServices";
import UserInfo from "../../Modal/Information/UserInfo/UserInfo";
import TableFixedPage from "../../TableFixedPage/TableFixedPage";
import UserSupportTable from "../../Tables/SupportMessagePart/UserSupportTable/UserSupportTable";
import { errorToast, succToast } from "../../../Utils/Toast/Toast";
import AdminSupportChat from "../../Tables/SupportMessagePart/AdminSupportChat/AdminSupportChat";
import UserFeedbackModal from "../../Modal/Information/UserFeedback/UserFeedbackModal";

const UserSupportContainer = () => {
  const [userInfo, setUserInfo] = useState(false);
  const [feedbackModalState, setFeedbackModalState] = useState(false);
  const [showChatState, setChatShowState] = useState(false);
  const [closeDiscussionModalState, setcloseDiscussionModalState] =
    useState(false);
  const [userSupportListState, setUserSupportListState] = useState([]);
  const [Info, setInfo] = useState([]);
  const [rawInfo, setRawInfo] = useState();
  // ///////////// get support /////////
  useEffect(() => {
    getSupportMessageHandler();
  }, []);

  const getSupportMessageHandler = async () => {
    getUserSupportApi((succ, res) => {
      if (succ) {
        if (res.status === 0) {
          errorToast("مشکلی پیش آمده است");
        } else {
          setUserSupportListState(res.support);
        }
      } else {
        errorToast("خطایی در سرور رخ داده است");
      }
    });
  };
  // ///////////////open modal///////////
  const showModal = async (id, info) => {
    setRawInfo(info);
    switch (id) {
      case 4:
        getUserInfoApi(info.user_id, (succ, res) => {
          if (res.status === 1) {
            setInfo(res.info);
          }
        });
        setUserInfo(true);
        break;
      case 1:
        setcloseDiscussionModalState(true);
        break;
      case 2:
        setChatShowState(true);
        break;
      case 3:
        setFeedbackModalState(true);
        break;

      default:
        break;
    }
  };

  const CloseDiscussionHandler = () => {
    let info = {
      id: rawInfo.id,
      status: 2,
    };
    supportStatusApi(info, (succ, res) => {
      if (succ) {
        if (res.status === 1) {
          succToast("عملیات با موفقیت انجام شد!");
          getSupportMessageHandler();
          setcloseDiscussionModalState(false);
        } else {
          errorToast(res.message);
        }
      } else {
        console.error(res);
      }
    });
  };
  const TitleStyle = {
    width: "100%",
    color: "#c20c64",
    textAlign: "center",
  };
  return (
    <div>
      <Modal
        show={closeDiscussionModalState}
        onHide={() => setcloseDiscussionModalState(false)}
      >
        <Modal.Header>
          <Modal.Title
            style={{ fontSize: "1rem", width: "100%", direction: "rtl" }}
          >
            آیا از اتمام درخواست موردنظر مطمئن هستید؟
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-around",
            }}
          >
            <button
              onClick={() => setcloseDiscussionModalState(false)}
              style={{
                border: "none",
                background: "#ffb5b5",
                color: "red",
                borderRadius: "0.25rem",
                width: "4rem",
              }}
            >
              خیر
            </button>
            <button
              onClick={CloseDiscussionHandler}
              style={{
                border: "none",
                background: "#c0ffb5",
                color: "green",
                borderRadius: "0.25rem",
                width: "4rem",
              }}
            >
              بله
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={showChatState} onHide={() => setChatShowState(false)}>
        <Modal.Title style={TitleStyle}>پاسخ</Modal.Title>
        <Modal.Body>
          <AdminSupportChat
            info={rawInfo}
            handelCloseModal={() => {
              setChatShowState(false);
              getSupportMessageHandler();
            }}
          />
        </Modal.Body>
      </Modal>
      <Modal show={feedbackModalState} onHide={() => setFeedbackModalState(false)}>
        <Modal.Title style={TitleStyle}>بازخورد مشتری</Modal.Title>
        <Modal.Body>
          <UserFeedbackModal info={rawInfo} handelClose={()=>setFeedbackModalState(false)}/>
        </Modal.Body>
      </Modal>

      <Modal show={userInfo} onHide={() => setUserInfo(false)}>
        <Modal.Title style={TitleStyle}>اطلاعات کاربر</Modal.Title>
        <Modal.Body>
          <UserInfo
            showAddress={false}
            Info={Info}
            handleOk={() => setUserInfo(false)}
          />
        </Modal.Body>
      </Modal>
      <TableFixedPage title={"پیام پشتیبانی کاربر"} />
      <UserSupportTable showModal={showModal} data={userSupportListState} />
    </div>
  );
};

export default UserSupportContainer;
